var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6314 65.8283C63.6314 68.574 61.4057 70.7997 58.66 70.7997H13.3425C10.5969 70.7997 8.37109 68.574 8.37109 65.8283V6.17114C8.37109 3.42549 10.5969 1.19971 13.3425 1.19971H58.66C61.4057 1.19971 63.6314 3.42549 63.6314 6.17114V65.8283Z",
    fill: "#FFCACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9627 34.0533C52.9627 36.799 50.7371 39.0248 47.9915 39.0248H24.0114C21.2658 39.0248 19.04 36.799 19.04 34.0533V15.7478C19.04 13.0022 21.2658 10.7764 24.0114 10.7764H47.9915C50.7371 10.7764 52.9627 13.0021 52.9627 15.7478V34.0533ZM22.4501 58.5922C22.4501 60.3083 23.8413 61.6994 25.5573 61.6994C27.2733 61.6994 28.6644 60.3083 28.6644 58.5922V56.9283H30.3301C32.0461 56.9283 33.4372 55.5373 33.4372 53.8211C33.4372 52.105 32.0461 50.7141 30.3301 50.7141H28.6644V49.0497C28.6644 47.3336 27.2733 45.9425 25.5573 45.9425C23.8413 45.9425 22.4501 47.3336 22.4501 49.0497V50.7141H20.7873C19.0713 50.7141 17.6802 52.105 17.6802 53.8211C17.6802 55.5373 19.0713 56.9283 20.7873 56.9283H22.4501V58.5922ZM48.4288 58.2263C51.1745 58.2263 53.4002 56.0006 53.4002 53.2549C53.4002 50.5092 51.1745 48.2834 48.4288 48.2834C45.6831 48.2834 43.4573 50.5092 43.4573 53.2549C43.4573 56.0006 45.6831 58.2263 48.4288 58.2263Z",
    fill: "#F84343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsp2);
export default __webpack_public_path__ + "static/media/dsp_2.dbf0845c34f913fa4d022ed720e8374e.svg";
export { ForwardRef as ReactComponent };